import { ActionClass } from '../../state';

export interface NotificationOptions {
  keepExisting: boolean;
  tags: (string | symbol)[];
  onDismiss: unknown;
  autoDismiss: boolean;
  spinnerInclusiveActions: ActionClass[];
  priorizationLevel: number | null;
}
